import React from 'react'
import './contact.css'
import {IoIosMail} from 'react-icons/io'
import {FaGithubSquare} from 'react-icons/fa'
import {RiDiscordFill} from 'react-icons/ri'
import { useRef as UseRef } from "react";
import emailjs from 'emailjs-com'
import TextScrambler from 'react-scramble-text'
import 'react-scramble-text/dist/index.css'

const data = {
  mail: "khdevelopment@gmail.com",
  github: "https://github.com/Killerhunter100",
  discord: "https://discord.gg/gEwsEn7WYy"
}

const contact = () => {
  const phrases = ["{Contact Us}", "{Contact Us} "]
  const form = UseRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_tfsl806', 'template_56u0loh', form.current, 'bRE4CUZS6Ux4awFeF')

    e.target.reset()
  };
  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2><TextScrambler phrases={phrases} speed={5} pauseTime={1000}/></h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <IoIosMail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>{data.mail}</h5>
            <a href="mailto:khdevelopment@gmail.com">Send a message</a>
          </article>
          <article className="contact__option">
            <FaGithubSquare className='contact__option-icon'/>
            <h4>Github</h4>
            <h5>{data.github}</h5>
            <a href={data.github}>Open Link</a>
          </article>
          <article className="contact__option">
            <RiDiscordFill className='contact__option-icon'/>
            <h4>Discord</h4>
            <h5>{data.discord}</h5>
            <a href={data.discord}>Join Discord</a>
          </article>
        </div>
        
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default contact